export class Assessment {
  id!: number;
  ward_number!: number;
  ward_name!: string;
  holding_number!: string;
  name!: string;
  gurdian_name!: string;
  mobile_number?: string;
  id_number?: string;
  vata!: string;
  pesha!: number;
  khanar_dhoron!: number;
  khanar_anumanik_mullo?: string;
  khanar_dharjokrito_kor?: string;
  gram_or_rasta?: string;
  post_office!: string;
  upozilla!: string;
  zilla!: string;
  qr_code!: string;
  subdomain?: string;
}
export class AssessmentSearch {
  ward_number!: number;
  holding_number!: string;
  gram_or_rasta!: string;
  serial_no_start?: number;
  serial_no_end?: number;
  is_sort_by_holding_number?: boolean;
}
